import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .optional-toggles {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .section-divider {
    border: none;
    border-top: 1px solid var(--sds-color-border-default-default);
    margin: 0;
    margin-left: var(--section-divider-margin-left, 0);
    margin-right: var(--section-divider-margin-right, 0);
    padding: 0;
  }

  .toggle-field {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .toggle-field wow-switch {
    --wow-switch-border-top: none;
  }

  .loading-links,
  .no-links {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    padding: 8px;
    text-align: center;
  }

  .link-selects {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .link-select-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .link-select-row wow-select {
    flex: 1;
  }

  .link-select-row wow-button {
    margin-top: 16px;
  }

  .link-select-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .link-scope-row {
    padding-left: 4px;
  }

  .add-extra-button {
    background: none;
    border: none;
    cursor: pointer;
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-brand-default);
    padding: 4px 0;
    text-align: left;
    align-self: flex-start;
    text-decoration: underline;
  }

  .add-extra-button:hover {
    text-decoration: none;
  }

  /* Community Picker */
  .community-picker {
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
  }

  .community-picker-header {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    gap: 8px;
  }

  .community-search-wrapper {
    flex: 1;
    min-width: 0;
  }

  .community-search {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .community-search::placeholder {
    color: var(--sds-color-text-default-tertiary);
  }

  .community-chevron {
    font-size: 10px;
    color: var(--sds-color-text-default-secondary);
    transition: transform 0.2s ease;
  }

  .community-chevron.expanded {
    transform: rotate(180deg);
  }

  .community-picker-list {
    border-top: 1px solid var(--sds-color-border-default-default);
    max-height: 200px;
    overflow-y: auto;
  }

  .community-picker-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    cursor: pointer;
  }

  .community-picker-item:hover {
    background: var(--sds-color-background-default-secondary);
  }

  .community-picker-item input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: var(--sds-color-background-brand-default);
    cursor: pointer;
    flex-shrink: 0;
  }

  .community-picker-label {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .community-picker-empty {
    padding: 12px;
    text-align: center;
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
  }

  .validation-error {
    font: var(--sds-typography-weight-regular) var(--sds-typography-body-size-small) var(--sds-typography-family-body);
    color: var(--sds-color-text-danger-secondary);
  }
`;
